import { useDispatch, useSelector } from "react-redux";
import {closeAllMenus, toggleMenu, closeMenu} from "../../app/slices/menu";

interface MenuState {
  isOpen: boolean;
  isOpenCompany: boolean;
  isQrMenuOpen: boolean;
  isProfileMenuOpen: boolean;
  isLangMenuOpen: boolean;
  isNotificationMenuOpen: boolean;
}

export const useMenu = (menuName: keyof MenuState) => {
  const dispatch = useDispatch();

  const open = useSelector((state: { menu: MenuState }) => state.menu.isOpen);
  const menu = useSelector((state: { menu: MenuState }) => state.menu[menuName]);

  const openMenuHandler = () => {
    dispatch(closeAllMenus({ excludeMenu: menuName }));
    dispatch(toggleMenu({ menuName }));
  };

  const closeMenuHandler = () => {
    dispatch(closeMenu({ menuName }));
  };

  return {open, menu, openMenuHandler, closeMenuHandler};
};